import type { ReactNode } from "react";
import styles from "./StatusPill.module.css";

export type StatusPillVariant =
  | "active"
  | "available"
  | "included"
  | "addon"
  | "premium"
  | "provisioning"
  | "warning"
  | "error";

type StatusPillProps = {
  variant: StatusPillVariant;
  children?: ReactNode;
  priceMonthly?: number;
};

const DEFAULT_LABELS: Record<StatusPillVariant, string> = {
  active: "Active",
  available: "Available",
  included: "Included",
  addon: "Add-on",
  premium: "Premium",
  provisioning: "Provisioning",
  warning: "Needs attention",
  error: "Needs attention",
};

const ANIMATED: ReadonlySet<StatusPillVariant> = new Set([
  "active",
  "provisioning",
]);

export const StatusPill = ({
  variant,
  children,
  priceMonthly,
}: StatusPillProps): JSX.Element => {
  const label = children ?? DEFAULT_LABELS[variant];
  const dotClass = ANIMATED.has(variant)
    ? `${styles.dot} ${styles.pulse}`
    : styles.dot;
  return (
    <span className={`${styles.pill} ${styles[variant]}`}>
      <span className={dotClass} aria-hidden />
      <span>{label}</span>
      {priceMonthly !== undefined ? (
        <span className={styles.price}>+${priceMonthly}/mo</span>
      ) : null}
    </span>
  );
};
